export default __webpack_public_path__ + "static/media/Error.89a0a1db.jpg";